import s from './GigAssChat.module.sass'

import { WaitingMessage, ConfusedMessage, CanceledMessage } from '@widgets/Common/GigAssist/components/GigAssMessage'
import { GigAssMessage } from '../GigAssMessage'
import { sendMessageRequest, cancelMessageRequest } from '../../model/actions'
import { useChatState } from '../../hooks/useChatState'

import { FC, useEffect } from 'react'
import type { FormEvent } from 'react'

import { useAppDispatch, useAppSelector } from '@app/model/store'
import type { RootState } from '@app/model/store'

import { scrollChat } from '@widgets/Common/GigAssist/helpers/scrollChat'

type GigAssChatProps = {
  isShowActive: boolean
}

/**
 * @function GigAssChat - компонент чата с ассистентом,
 *    который используется в виджете GigAssist.
 */
const GigAssChat: FC<GigAssChatProps> = ({ isShowActive }): JSX.Element => {
  const dispatch = useAppDispatch()

  const { messages, state } = useAppSelector((state: RootState) => state.gigAssist)

  useChatState({ state, messages })

  // * Скролл вниз при появлении нового сообщения *
  useEffect(() => {
    setTimeout(() => scrollChat('end'), 200)
  }, [messages])

  // * Скролл вниз при появлении сообщения о том, что что-то сломалось *
  useEffect(() => {
    if (state === 'confused') {
      setTimeout(() => scrollChat('end'), 150)
    }
  }, [state])

  const handleRetry = (e: FormEvent) => {
    e.preventDefault()
    const retryMessage = messages[messages.length - 1].text
    dispatch(sendMessageRequest(retryMessage))
  }

  const handleCancel = (e: FormEvent) => {
    e.preventDefault()
    dispatch(cancelMessageRequest())
  }

  const messageTag = 'li'
  const isShowMessages = messages && messages.length > 0

  return (
    <div className={`${s.chat} ${isShowActive ? s.active : ''}`}>
      {/* История сообщений */}
      {isShowMessages && (
        <ul data-name='gig-assist-messages' className={s.messages}>
          {messages.map((m) => (
            <GigAssMessage key={m.id} message={m} asElement={messageTag} />
          ))}

          {state === 'confused' && <ConfusedMessage onRetry={handleRetry} />}

          {state === 'canceled' && <CanceledMessage onRetry={handleRetry} />}

          {state === 'waiting' && <WaitingMessage onCancel={handleCancel} />}
        </ul>
      )}
    </div>
  )
}

export default GigAssChat
